const ITEMS = [
  "Optica",
  "Lintons Beauty",
  "Umoja Rubber",
  "Bandika IOT",
  "Forever Trendy",
  "Grace Kids and Teens",
  "Reen Secrets",
  "Splash Coffee",
  "Tonnie Lookz",
  "Hair Innovate",
  "Bliss Atelier Perfumes",
  "Mombasa Orthotex Supplies",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 select-none ${
        dark ? "bg-obsidian border-white/10" : "bg-ivory hairline border-y"
      }`}
    >
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
            <span
              className={`font-serif text-lg sm:text-xl italic tracking-wide ${
                dark ? "text-ivory/70" : "text-foreground/60"
              }`}
            >
              {item}
            </span>
            <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-brand-gold" : "bg-brand"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};
